/**
 * FORMAT CURRENCY
 * @type {Intl.NumberFormat}
 */
var formater = Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL"
});

/**
 * POPUP BUTTONS
 */
$("[data-popup]").click(function (e) {
    e.preventDefault();
    var data = $(this).data();

    // title
    $(".modal_title_" + data.popup_size).html(data.popup_title);

    // content
    if (data.popup == 'special') {
        $.post(url("/ingresso/especial"), function (response) {
            $(".modal_content_" + data.popup_size).html(response);
        });
    } else {
        $(".modal_content_" + data.popup_size).html(data.popup_description);
    }

    // open
    openModal("#modal_" + data.popup_size);
});


/**
 * LOADER
 */
function loaderShow() {
    loader.fadeIn(200);
}
function loaderClose() {
    loader.fadeOut(200);
}

//data- loader
$("[data-loader]").click(function () {
    loader.fadeIn(200);
});

/**
 * COPY TO CLIPBOARD
 */
$('body').on('click', '[data-copyboard]', function (e) {
    e.preventDefault();
    var data = $(this).data();

    var copyText = data.copyboard;

    var textarea = document.createElement("textarea");
    textarea.textContent = copyText;
    textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in MS Edge.
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");

    document.body.removeChild(textarea);
});

/**
 * SWITCH ALERT COPY TO CLIP BOARD
 */
$('body').on('click', '[data-copyboard-alert]', function (e) {
    e.preventDefault();
    Swal.fire({
        icon: 'success',
        title: 'Copiado para área de transferência.',
        showConfirmButton: false,
        timer: 1500
    });
});